'use client';
import React from 'react';
import { RenderHeaderCellProps } from 'react-data-grid';
import classNames from 'classnames';
import { getHeaderCellMetadata } from './lib';

import * as HeaderCellRenderer from '../FieldRenderers/HeaderCellRenderer';

export const getHeaderCellStatusClass = (added: boolean, removed: boolean, modified: boolean) => {
  return classNames('header-cell', {
    'header-cell-added': !!added,
    'header-cell-removed': !!removed,
    'header-cell-modified': !!modified,
  });
};

const SortElement: React.FC<{ sortDirection?: 'ASC' | 'DESC' }> = ({ sortDirection }) => {
  return sortDirection ? (
    <div className="header-cell-sort">
      {sortDirection === 'ASC' && '▲'}
      {sortDirection === 'DESC' && '▼'}
    </div>
  ) : null;
};

const CellRenderComponents: any = {
  diff_status: HeaderCellRenderer.DiffStatus,
  image: HeaderCellRenderer.Image,
  link: HeaderCellRenderer.Link,
  list: HeaderCellRenderer.List,
  struct: HeaderCellRenderer.Struct,
  bool: HeaderCellRenderer.Boolean,
  float: HeaderCellRenderer.Number,
  int: HeaderCellRenderer.Number,
  default: HeaderCellRenderer.String,
};

const HeaderCell: React.FC<RenderHeaderCellProps<any>> = (props) => {
  const { renderAs } = getHeaderCellMetadata(props);

  const CellRenderComponent = CellRenderComponents[renderAs] || CellRenderComponents.default;
  return (
    <CellRenderComponent {...props}>
      <SortElement sortDirection={props.sortDirection} />
    </CellRenderComponent>
  );
};

export default HeaderCell;
